/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TechCamVideoIcon20Light = forwardRef('TechCamVideoIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 4a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3h7a3 3 0 0 0 3-3v-.516l3.233 2.245A1.125 1.125 0 0 0 19 13.805v-7.61c0-.908-1.02-1.442-1.767-.924L14 7.516V7a3 3 0 0 0-3-3H4Zm10 4.734v2.532l3.804 2.642a.125.125 0 0 0 .196-.103v-7.61c0-.101-.113-.16-.196-.103L14 8.734ZM2 7a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V7Z" })));
});
